import React, { useEffect, useState } from "react";
import logodark from "../../assets/images/logo.png";
import logolight from "../../assets/images/logo.png";

import {
    Row,
    Col,
    CardBody,
    Card,
    Alert,
    Form,
    Input,
    FormFeedback,
    Label,
} from "reactstrap";

import { Link, useNavigate, useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";

import { PostData } from "../../services/api";

const ResetPassword = () => {
    document.title = "Restablecer contraseña | CRM IHG";
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token") || "";

    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [sending, setSending] = useState(false);
    const [showPass, setShowPass] = useState(false);

    useEffect(() => {
        return function cleanup() {
            document.body.className = "";
        };
    });

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            newPassword: "",
            confirmPassword: "",
        },
        validationSchema: Yup.object({
            newPassword: Yup.string()
                .min(8, "La contraseña debe tener al menos 8 caracteres")
                .required("Ingresa tu nueva contraseña"),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref("newPassword")], "Las contraseñas no coinciden")
                .required("Confirma tu nueva contraseña"),
        }),
        onSubmit: async (values) => {
            setErrorMsg("");
            setSuccessMsg("");
            if (!token) {
                setErrorMsg("El enlace de recuperación es inválido. Solicita uno nuevo.");
                return;
            }
            setSending(true);
            try {
                const res = await PostData("/users/reset-password", {
                    token,
                    newPassword: values.newPassword,
                });
                setSuccessMsg(
                    res?.data?.message ||
                    "Tu contraseña se actualizó correctamente. Ya puedes iniciar sesión."
                );
                setTimeout(() => navigate("/login"), 2500);
            } catch (err) {
                setErrorMsg(
                    err?.response?.data?.error?.message ||
                    err?.message ||
                    "No pudimos restablecer tu contraseña. El enlace pudo expirar."
                );
            } finally {
                setSending(false);
            }
        },
    });

    return (
        <React.Fragment>
            <div className="accessSpace">
                <div className="leftColAccess passRec"></div>
                <div className="rightColAccess">
                    <div className="d-flex flex-column">
                        <Card className="w-full flex-column d-flex">
                            <CardBody className="p-4">
                                <div>
                                    <div className="text-center">
                                        <img
                                            src={logodark}
                                            alt="InnovaHubGroup"
                                            className="auth-logo logo-dark mx-auto"
                                        />
                                        <img
                                            src={logolight}
                                            alt="InnovaHubGroup"
                                            className="auth-logo logo-light mx-auto"
                                        />
                                    </div>

                                    <div className="text-center mt-2 mb-4">
                                        <h5>Nueva contraseña</h5>
                                        <p className="text-muted">
                                            Elige una contraseña nueva para tu cuenta.
                                        </p>
                                    </div>

                                    {!token ? (
                                        <Alert color="danger">
                                            El enlace de recuperación es inválido o está incompleto.
                                            Solicita uno nuevo desde{" "}
                                            <Link to="/password-recovery">recuperar contraseña</Link>.
                                        </Alert>
                                    ) : null}

                                    <Form
                                        className="form-horizontal"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                    >
                                        {errorMsg ? (
                                            <Alert color="danger">
                                                <div>{errorMsg}</div>
                                            </Alert>
                                        ) : null}
                                        {successMsg ? (
                                            <Alert color="success">
                                                <div>{successMsg}</div>
                                            </Alert>
                                        ) : null}

                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label">
                                                        Nueva contraseña
                                                    </Label>
                                                    <Input
                                                        name="newPassword"
                                                        className="form-control"
                                                        placeholder="Mínimo 8 caracteres"
                                                        type={showPass ? "text" : "password"}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.newPassword || ""}
                                                        invalid={
                                                            validation.touched.newPassword &&
                                                                validation.errors.newPassword
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {validation.touched.newPassword &&
                                                        validation.errors.newPassword ? (
                                                        <FormFeedback type="invalid">
                                                            <div>{validation.errors.newPassword}</div>
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <Label className="form-label">
                                                        Confirmar contraseña
                                                    </Label>
                                                    <Input
                                                        name="confirmPassword"
                                                        className="form-control"
                                                        placeholder="Repite la contraseña"
                                                        type={showPass ? "text" : "password"}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.confirmPassword || ""}
                                                        invalid={
                                                            validation.touched.confirmPassword &&
                                                                validation.errors.confirmPassword
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {validation.touched.confirmPassword &&
                                                        validation.errors.confirmPassword ? (
                                                        <FormFeedback type="invalid">
                                                            <div>{validation.errors.confirmPassword}</div>
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="form-check mb-3">
                                                    <Input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="showPass"
                                                        checked={showPass}
                                                        onChange={() => setShowPass((v) => !v)}
                                                    />
                                                    <Label className="form-check-label" htmlFor="showPass">
                                                        Mostrar contraseña
                                                    </Label>
                                                </div>

                                                <div className="d-grid mt-4">
                                                    <button
                                                        className="btn btn-primary waves-effect waves-light"
                                                        type="submit"
                                                        disabled={sending || !token || !!successMsg}
                                                    >
                                                        {sending ? "Guardando..." : "Restablecer contraseña"}
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>

                                    <Col className="text-center">
                                        <div className="text-center mt-3">
                                            <Link to="/login" className="text-muted">
                                                <i className="mdi mdi-unlock"></i> Volver a iniciar sesión
                                            </Link>
                                        </div>
                                    </Col>
                                </div>
                            </CardBody>
                        </Card>
                        <div className="mt-5 text-center">
                            <p className="text-black">
                                © {new Date().getFullYear()}
                                <i className="mdi mdi-heart text-danger"></i> InnovaHubGroup
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ResetPassword;
